import ReturnCodeInput from "@/components/common/ReturnCodeInput";
import DropOffSelect from "@/components/dropoff-select/DropOffSelect";
import { NavigationRoutes } from "@/components/navigation/constants";
import SellerSelect from "@/components/supplier-select/SellerSelect";
import { RequestModes_ } from "@/constants/constants";
import { HUB } from "@/interfaces/HUB";
import { Seller } from "@/interfaces/Seller";
import { closeDialog } from "@/store/reducers/dialogReducer";
import { setReturnHeader } from "@/store/reducers/returnHeaderReducer";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DialogFooter_ } from "./DialogFooter";

interface StandardCreationFormProps {}

export const StandardCreationForm: React.FC<
  StandardCreationFormProps
> = ({}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [returnCode, setReturnCode] = useState<number>(0);
  const [selectedSeller, setSelectedSeller] = useState<Seller>({} as Seller);
  const [selectedDropOff, setSelectedDropOff] = useState<HUB>({} as HUB);

  const handleRedirectToScanPage = () => {
    dispatch(closeDialog());
    dispatch(
      setReturnHeader({
        seller: selectedSeller,
        returnCode: returnCode,
      })
    );
    navigate(NavigationRoutes.RETURN_CREATE);
  };

  const disabledCheck = () => {
    return !(selectedSeller.sellerId && returnCode !== 0);
  };

  return (
    <>
      <div className="flex gap-4 w-full">
        <div className="flex flex-col gap-4 w-full">
          <ReturnCodeInput setReturnCode_={setReturnCode} />

          <SellerSelect
            mode={RequestModes_.DEFAULT}
            selectedSeller={selectedSeller}
            setSelectedSeller={setSelectedSeller}
          />
          <DropOffSelect
            selectedDropOff={selectedDropOff}
            setSelectedDropOff={setSelectedDropOff}
          />
        </div>
      </div>
      <DialogFooter_
        confirmationMode={false}
        disabled={disabledCheck()}
        loading={false}
        handleSubmit={handleRedirectToScanPage}
      />
    </>
  );
};

export default StandardCreationForm;
